export enum EAuthTypes {
    SET_LOGIN_ERROR = '@auth/login/setError',
    SET_CLIENT_INFO_STAGE = '@auth/clientInfoStage/set',
    SET_CLIENT_PERSONAL = '@auth/clientPersonal/set',
    FETCH_CLIENT_PAYMENT = '@auth/clientPayment/fetch',
    SET_CLIENT_PAYMENT = '@auth/clientPayment/set',
    ERROR_CLIENT_PAYMENT = '@auth/clientPayment/setError',
    SET_CLIENT_PRODUCTS = '@auth/clientProducts/set',
    CLIENT_PRODUCTS_LOADING = '@auth/clientProducts/loading',
    SET_CLIENT_CONTACTS = '@auth/clientContacts/set',
    CLIENT_CONTACTS_LOADING = '@auth/clientContacts/loading',
    SET_PAYMENT_DAY_INFO = '@auth/paymentDayInfo/set',

    LOGIN = '@auth/login',
    SET_IS_AUTH = '@auth/setIsAuth',

    SET_CSRF_TOKEN = '@auth/csrfToken/set',

    SET_STATUS = '@agreements/status/set',
    SET_AGREEMENTS = '@agreements/list/set',
}
